import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject, Observable } from 'rxjs'

export interface Bootstrap_Modal_Service_Config {
  modal_header_html: string
  modal_body_html: string
  modal_color_variant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'default'

  modal_submit_button_display?: boolean
  modal_close_button_display?: boolean
  modal_cancel_button_display?: boolean
}
@Injectable({
  providedIn: 'root'
})
export class Bootstrap_Modal_Service {

  private modalSubject = new BehaviorSubject<Bootstrap_Modal_Service_Config | null>(null)
  modal$ = this.modalSubject.asObservable()

  private modalResult$?: Subject<'submit' | 'close'>

  open(config: Bootstrap_Modal_Service_Config): Observable<'submit' | 'close'> {
    this.modalResult$ = new Subject<'submit' | 'close'>()

    this.modalSubject.next(config)
    return this.modalResult$.asObservable()
  }

  submit() {
    this.modalResult$?.next('submit')
    this.modalResult$?.complete()
    this.close()
  }

  close() {
    this.modalResult$?.next('close')
    this.modalResult$?.complete()
    this.modalSubject.next(null)
  }
}
